<nz-layout>
  <nz-sider
    nzCollapsible
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    [nzWidth]="240"
    [nzCollapsedWidth]="80"
  >
    <div class="logo"></div>

    <ul nz-menu nzTheme="dark" nzMode="inline">
      <li nz-menu-item routerLinkActive="ant-menu-item-selected">
        <a [routerLink]="['/companies']">
          <span nz-icon nzType="global"></span>
          <span>Organizacja</span>
        </a>
      </li>

      <li nz-menu-item routerLinkActive="ant-menu-item-selected">
        <a [routerLink]="['/users']">
          <span nz-icon nzType="user"></span>
          <span>Użytkownicy</span>
        </a>
      </li>

      <li nz-submenu nzTitle="Kody" nzIcon="folder">
        <ul>
          <li nz-menu-item>
            <a [routerLink]="['/codes/icd10']">ICD-10</a>
          </li>

          <li nz-menu-item>
            <a [routerLink]="['/codes/icd8']">ICD-8</a>
          </li>

          <li nz-menu-item>
            <a [routerLink]="['/codes/icd9']">ICD-9</a>
          </li>
        </ul>
      </li>

      <li nz-submenu nzTitle="NFZ" nzIcon="plus-circle">
        <ul>
          <li nz-menu-item>
            <a [routerLink]="['/nfz/ewus-kolce']"> eWUŚ / Kolce </a>
          </li>

          <li nz-menu-item>
            <a [routerLink]="['/nfz/p1']"> P1 </a>
          </li>
          <li nz-menu-item>
            <a [routerLink]="['/nfz/settlements']"> Rozliczenia </a>
          </li>
        </ul>
      </li>

      <li nz-menu-item routerLinkActive="ant-menu-item-selected">
        <a [routerLink]="['/service-providers']">
          <span nz-icon nzType="shop"></span>
          <span>Podmioty</span>
        </a>
      </li>

      <li nz-submenu nzTitle="Procedury" nzIcon="tag">
        <ul>
          <li nz-menu-item>
            <a [routerLink]="['/procedures']"> Procedury </a>
          </li>

          <li nz-menu-item>
            <a [routerLink]="['/procedure-sets']"> Zestawy </a>
          </li>
        </ul>
      </li>
    </ul>
  </nz-sider>

  <nz-layout>
    <nz-header>
      <nz-icon
        class="trigger"
        [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
        (click)="isCollapsed = !isCollapsed"
      >
      </nz-icon>

      <app-user-info></app-user-info>
    </nz-header>

    <nz-content>
      <nz-breadcrumb>
        /
        @for (breadcrumb of breadcrumbService.breadcrumbs(); track breadcrumb.url) {
          <nz-breadcrumb-item>
            @if (breadcrumb.isCurrent) {
              <span>{{ breadcrumb.label }}</span>
            } @else {
              <a [routerLink]="breadcrumb.url">
                {{ breadcrumb.label }}
              </a>
            }
          </nz-breadcrumb-item>
        }
      </nz-breadcrumb>

      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>

    <nz-footer> MHS Manager ©{{ date.getFullYear() }} </nz-footer>
  </nz-layout>
</nz-layout>
